import { AddIcon, EditIcon, } from './IconButtons';
import CloseModal from './CloseModal';
import InputField, { FileInput } from './InputField';
import CountryCodeDropdown from './CountryCodeDropdown';
import { countryPhoneCode, currencyList } from '../Constants/constant';
import Dropdown, { CurrencyDropdown } from './Dropdown';

const AddCandidate = ({data,companyList, positionList, errors, loading, disabled, onChange, onClose, onEdit, onCancel, onSubmit }) => {
    const candidateEctcTypeOptions = [
        {value: "1", label: "LPA"},
        {value: "2", label: "%"},
    ];
    const genderOptions = [
        {value: "Male", label: "Male"},
        {value: "Female", label: "Female"},
    ];
    const relevantOptions = [
        {value: "Yes", label: "Yes"},
        {value: "No", label: "No"},
    ];
    const statusOptions = [
        {value: "Rejected", label: "Rejected"},
        {value: "Confirmation Pending", label: "Confirmation Pending"},
        {value: "Screened", label: "Screened"},
    ];
    // console.log("data?.position_questions",data?.position_questions);

    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[70vw] bg-white overflow-auto mx-10 mb-5 py-5 px-8 rounded-2xl '>
                {onEdit && disabled ? 
                    <EditIcon disabled={loading} className=" top-3 left-8" onClick={onEdit} /> :
                    <AddIcon disabled={loading} loading={loading} btnName='Submit' className=" top-3 left-10" onClick={onSubmit} />
                    }
                <CloseModal disabled={loading} onClick={onClose} />
                <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Source Candidate</h1>
                <form className='text-left flex flex-col gap-x-4 gap-y-3 px-2 max-h-[70vh] overflow-y-scroll'>
                    <div className='grid grid-cols-2 gap-3'>
                        <Dropdown id="company_id" name="company_id"
                            label="Company:"
                            onChange={onChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            disabled={disabled}
                            placeholder={`Select Company`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.company_id}
                            error={errors?.company_id}
                            options={companyList}
                            search={true}
                            required={true}
                        />
                        <Dropdown id="position_id" name="position_id"
                            label="Position:"
                            onChange={onChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Select Position`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.position_id}
                            error={errors?.position_id}
                            options={positionList}
                            search={true}
                            required={data?.company_id}
                        />
                        <InputField
                            id="location"
                            name="location"
                            label="Location:"
                            type="text"
                            disabled={true}
                            placeholder="Location"
                            textColor={disabled && "text-blue-700"}
                            value={data?.location}
                            error={errors?.location}
                            onChange={onChange}
                        />
                        <InputField
                            id="min_ctc"
                            name="min_ctc"
                            label="Min CTC:"
                            type="text"
                            disabled={true}
                            placeholder="Min CTC"
                            textColor={disabled && "text-blue-700"}
                            value={data?.min_ctc}
                            error={errors?.min_ctc}
                            onChange={onChange}
                        />
                        <InputField
                            id="max_ctc"
                            name="max_ctc"
                            label="Max CTC:"
                            type="text"
                            disabled={true}
                            placeholder="Max CTC"
                            textColor={disabled && "text-blue-700"}
                            value={data?.max_ctc}
                            error={errors?.max_ctc}
                            onChange={onChange}
                        />
                        <InputField
                            id="cv_sourced_from"
                            name="cv_sourced_from"
                            label="CV Sourced From:"
                            type="text"
                            disabled={disabled || !data?.company_id}
                            placeholder="Sourced From"
                            textColor={disabled && "text-blue-700"}
                            value={data?.cv_sourced_from}
                            error={errors?.cv_sourced_from}
                            onChange={onChange}
                            required={data?.company_id}
                        />
                        <Dropdown id="relevant" name="relevant"
                            label="Relevant:"
                            onChange={onChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Select`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.relevant}
                            error={errors?.relevant}
                            options={relevantOptions}
                            required={data?.company_id}
                        />
                        <Dropdown id="sourcing_status" name="sourcing_status"
                            label="Sourcing Status:"
                            onChange={onChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Select Status`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.sourcing_status}
                            error={errors?.sourcing_status}
                            options={statusOptions}
                            required={data?.company_id}
                        />
                        <InputField
                            id="candidate"
                            name="candidate"
                            label="Name:"
                            type="text"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Enter Name`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate}
                            error={errors?.candidate}
                            onChange={onChange}
                            required={data?.company_id}
                        />
                        <InputField
                            id="candidate_email"
                            name="candidate_email"
                            label="Email:"
                            type="email"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Enter Email`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_email}
                            error={errors?.candidate_email}
                            onChange={onChange}
                            required={data?.company_id}
                        />
                        <div>
                            <h2 className='flex text-left font-medium text-gray-700 mb-1'>Mobile:
                                {data?.company_id && (
                                    <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                    <span className=" absolute top-[-2px] left-[3px]">*</span>
                                    </span>
                                )}
                            </h2>
                            <div className="flex items-start gap-2">
                                <CountryCodeDropdown id="phone_code" name="phone_code"
                                    onChange={onChange}
                                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                    disabled={disabled || !data?.company_id}
                                    placeholder={`Country Code`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.phone_code}
                                    error={errors?.phone_code}
                                    options={countryPhoneCode}
                                />
                                <InputField
                                    id="candidate_phone"
                                    name="candidate_phone"
                                    type="text"
                                    disabled={disabled || !data?.company_id}
                                    placeholder={`Enter Mobile Number`}
                                    textColor={disabled && "text-blue-700"}
                                    className="flex-1"
                                    value={data?.candidate_phone}
                                    error={errors?.candidate_phone}
                                    onChange={onChange}
                                />
                                
                            </div>
                        </div>
                        <div>
                            <h2 className='block text-left font-medium text-gray-700 mb-1'>Alternate Mobile:</h2>
                            <div className="flex flex-grow items-start gap-2">
                                <CountryCodeDropdown id="phone_alt_code" name="phone_alt_code"
                                    onChange={onChange}
                                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                    disabled={disabled || !data?.company_id}
                                    placeholder={`Country Code`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.phone_alt_code}
                                    error={errors?.phone_alt_code}
                                    options={countryPhoneCode}
                                />
                                <InputField
                                id="candidate_alt_phone"
                                name="candidate_alt_phone"
                                type="text"
                                disabled={disabled || !data?.company_id}
                                placeholder={`Enter Mobile Numbe`}
                                textColor={disabled && "text-blue-700"}
                                className="flex-1"
                                value={data?.candidate_alt_phone}
                                error={errors?.candidate_alt_phone}
                                onChange={onChange}
                                />
                            </div>
                        </div>
                        <InputField
                            id="candidate_location"
                            name="candidate_location"
                            label="Location:"
                            type="text"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Location`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_location}
                            error={errors?.candidate_location}
                            onChange={onChange}
                            required={data?.sourcing_status === "Screened"}
                        />
                        <InputField
                            id="candidate_qualification"
                            name="candidate_qualification"
                            label="Qualification:"
                            type="text"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Qualification`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_qualification}
                            error={errors?.candidate_qualification}
                            onChange={onChange}
                            required={data?.sourcing_status === "Screened"}
                        />
                        <div>
                            <h2 className='flex text-left font-medium text-gray-700 mb-1'>Current CTC:
                                {data?.sourcing_status === "Screened" && (
                                    <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                    <span className=" absolute top-[-2px] left-[3px]">*</span>
                                    </span>
                                )}
                            </h2>
                            <div className='flex flex-grow items-start gap-2'>
                                <CurrencyDropdown 
                                    id="current_currency_code" 
                                    name="current_currency_code" 
                                    onChange={onChange}
                                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                    disabled={disabled || !data?.company_id}
                                    placeholder={`Currency`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.current_currency_code}
                                    options={currencyList}
                                />
                                <InputField
                                    id="candidate_current_ctc"
                                    name="candidate_current_ctc"
                                    className="flex-1"
                                    type="text"
                                    disabled={disabled || !data?.company_id}
                                    placeholder={`Current CTC`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.candidate_current_ctc}
                                    error={errors?.candidate_current_ctc}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div>
                            <h2 className='flex text-left font-medium text-gray-700 mb-1'>Expected CTC:
                                {data?.sourcing_status === "Screened" && (
                                    <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                    <span className=" absolute top-[-2px] left-[3px]">*</span>
                                    </span>
                                )}
                            </h2>
                                <div className='flex flex-grow items-start gap-2'>
                                    <Dropdown 
                                        id="candidate_ectc_type" 
                                        name="candidate_ectc_type"
                                        onChange={onChange}
                                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                        disabled={disabled || !data?.company_id}
                                        placeholder={`Type`}
                                        textColor={disabled && "text-blue-700"}
                                        value={data?.candidate_ectc_type}
                                        error={errors?.candidate_ectc_type}
                                        options={candidateEctcTypeOptions}
                                    />
                                    <CurrencyDropdown id="expected_currency_code" name="expected_currency_code" 
                                        // label="Currency:"
                                        onChange={onChange}
                                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                        disabled={disabled || !data?.company_id}
                                        placeholder={`Currency`}
                                        textColor={disabled && "text-blue-700"}
                                        value={data?.expected_currency_code}
                                        options={currencyList}
                                    />
                                    {/* {data?.candidate_ectc_type && ( */}
                                        <InputField
                                            id="candidate_expected_ctc"
                                            name="candidate_expected_ctc"
                                            type="text"
                                            className="flex-1"
                                            disabled={disabled || !data?.candidate_ectc_type || !data?.company_id}
                                            placeholder={`Expected CTC`}
                                            textColor={disabled && "text-blue-700"}
                                            value={data?.candidate_expected_ctc}
                                            error={errors?.candidate_expected_ctc}
                                            onChange={onChange}
                                        />
                                    {/* )} */}
                                    {/* <ErrorMessage name="candidate_ectc_type" component="div" className="text-red-600 text-sm" /> */}
                                </div>
                        </div>
                        <InputField  
                        id="candidate_dob" 
                        name="candidate_dob" 
                        label="Date Of Birth:"
                        type="date" 
                        disabled={disabled || !data?.company_id}
                        textColor={disabled && "text-blue-700"}
                        value={data?.candidate_dob}
                        error={errors?.candidate_dob}
                        onChange={onChange}
                        />
                        <InputField
                        id="candidate_industry"
                        name="candidate_industry"
                        label="Industry:"
                        type="text"
                        disabled={disabled || !data?.company_id}
                        placeholder={`Current/Past Industry`}
                        textColor={disabled && "text-blue-700"}
                        value={data?.candidate_industry}
                        error={errors?.candidate_industry}
                        onChange={onChange}
                        required={data?.sourcing_status === "Screened"}
                        />
                        <InputField
                            id="candidate_organization"
                            name="candidate_organization"
                            label="Organization:"
                            type="text"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Current/Past Organization`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_organization}
                            error={errors?.candidate_organization}
                            onChange={onChange}
                        />
                        <InputField
                            id="candidate_designation"
                            name="candidate_designation"
                            label="Designation:"
                            type="text"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Current/Past Designation`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_designation}
                            error={errors?.candidate_designation}
                            onChange={onChange}
                        />
                        <InputField
                            id="candidate_experience"
                            name="candidate_experience"
                            label="Experience:"
                            type="text"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Experience`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_experience}
                            error={errors?.candidate_experience}
                            onChange={onChange}
                            required={data?.sourcing_status === "Screened"}
                        />
                        <InputField
                            id="candidate_notice_period"
                            name="candidate_notice_period"
                            label="Notice Period:"
                            type="text"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Notice Period In Days`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_notice_period}
                            error={errors?.candidate_notice_period}
                            onChange={onChange}
                            required={data?.sourcing_status === "Screened"}
                        />
                        <Dropdown 
                            id="candidate_gender" 
                            name="candidate_gender"
                            label="Gender:"
                            onChange={onChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            disabled={disabled || !data?.company_id}
                            placeholder={`Select`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_gender}
                            error={errors?.candidate_gender}
                            options={genderOptions}
                            required={data?.sourcing_status === "Screened"}
                        />
                        <FileInput
                        name="candidate_resume"
                        label="Upload Resume:"
                        placeholder={`Upload`}
                        accept=".pdf,.doc,.docx"
                        disabled={disabled || !data?.company_id}
                        value={data?.candidate_resume}
                        error={errors?.candidate_resume}
                        onSelect={onChange} />
                    </div>
                    <div>
                        <h2 className='block text-left font-medium text-gray-700 mb-1'>Remarks</h2>
                        <textarea name="candidate_remarks" id="candidate_remarks" rows="5"
                        className='w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                        disabled={disabled || !data?.company_id} placeholder="Enter Remark..." onChange={onChange}
                        >{data?.candidate_remarks}
                        </textarea>
                    </div>
                    <hr className=' mt-2' />
                    { Array.isArray(data?.position_questions) && (data?.position_questions.length > 0) &&
                    ( <><h1 className='text-center text-xl font-semibold text-blue-950'>Related Questions</h1>
                    <div className='grid grid-cols-1 gap-3 mt-3 '>
                        {data?.position_questions?.map((item, idx) => (
                            <div key={idx} className="w-full mb-4 p-4 border rounded-md shadow-sm bg-gray-50">
                                <div className="flex justify-between items-start">
                                <div className="w-full">
                                    <h2 className="text-sm font-semibold text-gray-700 mb-1">{`Question ${idx + 1}${item?.is_mandatory == 1 ? ' *' : ''}`}</h2>
                                    <p className="text-gray-800 mb-2">{item?.question_text}</p>
                                    <InputField
                                        id={`answer`}
                                        name={`answer`}
                                        className="w-full"
                                        placeholder="Write your answer"
                                        value={item?.response_text}
                                        error={item?.error_text}
                                        onChange={(e)=> onChange(e,item.question_id)}
                                    />
                                </div>
                                </div>
                            </div>
                        ))}

                    </div></>)}
                </form>
            </div>
        </div>
    );
}

export default AddCandidate;
